import { validatePhoneNumber } from '@/core/lib/utils/validators'
import { TranslationFunction } from '@/i18n/types'
import z from 'zod'

export const getSendVerificationCodeValidation = (t: TranslationFunction) => {
  const schema = z.object({
    phoneNumber: z
      .string()
      .min(1, {
        message: t('validation.phoneReq'),
      })
      .refine(validatePhoneNumber, {
        message: t('validation.phoneErr'),
      }),
  })
  return { schema }
}
